import * as Yup from 'yup'
import { PHOTO_STUDIO_LOCATION } from 'domains/seller-inventory-batch/constants'

Yup.addMethod(Yup.array, 'unique', function(message, mapper = (a) => a) {
  return this.test('unique', message, function(list) {
    return list.length  === new Set(list.map(mapper)).size
  })
})

const sellerInventoryBatchCreateSchema = Yup.object().shape({
  photo_studio_location: Yup.string().oneOf(
    Object.values(PHOTO_STUDIO_LOCATION),
    `Harus satu dari ${Object.values(PHOTO_STUDIO_LOCATION).join(', ')}`
  ).required('Required'),
  skus: Yup.array()
    .of(
      Yup.object().shape({
        sku: Yup.string().required('Required')
      })).unique('Setiap inbound item harus unik', (skus) => skus.sku)
    .min(1, 'Minimum one item is filled')
    .required('Required')
})

export default sellerInventoryBatchCreateSchema